<!--
 * @Description: 潜在客户新增编辑
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-11-17 16:53:04
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <baseMessage :disabled="false" :permissionPage="permissionBasic" :data="data" type="potential" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import baseMessage from '@/views/overseasSales/customerCenter/components/baseMessage.vue'
import { useRoute } from 'vue-router'
import { potentialDetail } from '@/api/overseasSales/customerCenter'
const route = useRoute()
const data = ref({})
// 获取详情
const fetch = () => {
  if (route.query.cosId) {
    potentialDetail(route.query.cosId).then((res) => {
      if (res.data.business && res.data.business.businessType && res.data.business.businessType?.length > 0) {
        res.data.business.businessTypeSelect = res.data.business.businessType[0]
      }
      if (!res.data.business.contractInfo) {
        res.data.business.contractInfo = { billingTerm: 3475 }
      } else {
        if (res.data.business.contractInfo.paymentType === 3504 || res.data.business.contractInfo.paymentType === 3473) {
          if (!res.data.business.contractInfo.paymentTerm) {
            res.data.business.contractInfo.paymentTerm = '10'
          }
        }
      }
      if (res.data.business.contractInfo && !res.data.business.contractInfo.billingTerm) {
        res.data.business.contractInfo.billingTerm = 3475
      }
      data.value = res.data
    })
  }
}
const permissionBasic = {
  save: 'ofbu_potential_edit_btn',
  editCode: 'ofbu_potential_edit_name_or_code_btn'
}
onMounted(() => {
  fetch()
})
</script>
<script lang="ts">
export default { name: 'DcCosOFbuPotentialPerEdit' }
</script>
<style lang="scss" scoped></style>
